import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import { reducer as formReducer } from "redux-form";
import loginInfo from "./auth";
import post from "./post";
import category from "./category";
import user from "./user";
import config from "./config";
import fileUpload from "./file";
import royaltiesEditor from "./royalties_editor";
import homepage from "./home";
const rootReducer = history =>
  combineReducers({
    loginInfo,
    fileUpload,
    post,
    category,
    user,
    config,
    homepage,
    royaltiesEditor,
    form: formReducer,
    router: connectRouter(history)
  });

export default rootReducer;
